const STATUSES = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  MISSING: 'MISSING',
};

export { STATUSES };
